import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAutoApplyEligiblePastAnswersQueryVariables = Types.Exact<{
    first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
    after?: Types.InputMaybe<Types.Scalars['String']['input']>;
    shouldIncludeHostedSQ?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetAutoApplyEligiblePastAnswersQuery = {
    __typename?: 'Query';
    autoApplyEligiblePastAnswers?:
        | {
              __typename?: 'AutoApplyEligiblePastAnswersConnection';
              totalCount: number;
              edges: Array<{
                  __typename?: 'AutoApplyEligiblePastAnswerEdge';
                  cursor: string;
                  node: {
                      __typename?: 'AutoApplyEligiblePastAnswer';
                      question: {
                          __typename?: 'AutoApplyEligibleQuestion';
                          id: string;
                          intentId: string;
                          type: Types.AutoApplyEligibleQuestionType;
                          question: string;
                          options: Array<{
                              __typename?: 'AutoApplyEligibleQuestionOption';
                              value: string;
                              label: string;
                              attributeId?: string | null | undefined;
                          }>;
                      };
                      answers: Array<{
                          __typename?: 'AutoApplyPastAnswerValue';
                          values: Array<string>;
                          createdAt: any;
                      }>;
                  };
              }>;
              pageInfo: {
                  __typename?: 'PageInfo';
                  hasNextPage: boolean;
                  hasPreviousPage: boolean;
                  startCursor?: string | null | undefined;
                  endCursor?: string | null | undefined;
              };
          }
        | null
        | undefined;
};

export type GetSqPrefillPreferenceQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSqPrefillPreferenceQuery = {
    __typename?: 'Query';
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              sqPastAnswerPrefillPreference?:
                  | Types.SqPastAnswerPrefillPreference
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export const GetAutoApplyEligiblePastAnswersDocument = gql`
    query GetAutoApplyEligiblePastAnswers(
        $first: Int
        $after: String
        $shouldIncludeHostedSQ: Boolean
    ) {
        autoApplyEligiblePastAnswers(
            first: $first
            after: $after
            shouldIncludeHostedSQ: $shouldIncludeHostedSQ
        ) {
            edges {
                cursor
                node {
                    question {
                        id
                        intentId
                        type
                        question
                        options {
                            value
                            label
                            attributeId
                        }
                    }
                    answers {
                        values
                        createdAt
                    }
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            totalCount
        }
    }
`;

/**
 * __useGetAutoApplyEligiblePastAnswersQuery__
 *
 * To run a query within a React component, call `useGetAutoApplyEligiblePastAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoApplyEligiblePastAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoApplyEligiblePastAnswersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      shouldIncludeHostedSQ: // value for 'shouldIncludeHostedSQ'
 *   },
 * });
 */
export function useGetAutoApplyEligiblePastAnswersQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAutoApplyEligiblePastAnswersQuery,
        GetAutoApplyEligiblePastAnswersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetAutoApplyEligiblePastAnswersQuery,
        GetAutoApplyEligiblePastAnswersQueryVariables
    >(GetAutoApplyEligiblePastAnswersDocument, options);
}
export function useGetAutoApplyEligiblePastAnswersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAutoApplyEligiblePastAnswersQuery,
        GetAutoApplyEligiblePastAnswersQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAutoApplyEligiblePastAnswersQuery,
        GetAutoApplyEligiblePastAnswersQueryVariables
    >(GetAutoApplyEligiblePastAnswersDocument, options);
}
export function useGetAutoApplyEligiblePastAnswersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAutoApplyEligiblePastAnswersQuery,
              GetAutoApplyEligiblePastAnswersQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAutoApplyEligiblePastAnswersQuery,
        GetAutoApplyEligiblePastAnswersQueryVariables
    >(GetAutoApplyEligiblePastAnswersDocument, options);
}
export type GetAutoApplyEligiblePastAnswersQueryHookResult = ReturnType<
    typeof useGetAutoApplyEligiblePastAnswersQuery
>;
export type GetAutoApplyEligiblePastAnswersLazyQueryHookResult = ReturnType<
    typeof useGetAutoApplyEligiblePastAnswersLazyQuery
>;
export type GetAutoApplyEligiblePastAnswersSuspenseQueryHookResult = ReturnType<
    typeof useGetAutoApplyEligiblePastAnswersSuspenseQuery
>;
export type GetAutoApplyEligiblePastAnswersQueryResult = Apollo.QueryResult<
    GetAutoApplyEligiblePastAnswersQuery,
    GetAutoApplyEligiblePastAnswersQueryVariables
>;
export const GetSqPrefillPreferenceDocument = gql`
    query GetSqPrefillPreference {
        autoApplyInfo {
            sqPastAnswerPrefillPreference
        }
    }
`;

/**
 * __useGetSqPrefillPreferenceQuery__
 *
 * To run a query within a React component, call `useGetSqPrefillPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSqPrefillPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSqPrefillPreferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSqPrefillPreferenceQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetSqPrefillPreferenceQuery,
        GetSqPrefillPreferenceQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetSqPrefillPreferenceQuery, GetSqPrefillPreferenceQueryVariables>(
        GetSqPrefillPreferenceDocument,
        options,
    );
}
export function useGetSqPrefillPreferenceLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSqPrefillPreferenceQuery,
        GetSqPrefillPreferenceQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetSqPrefillPreferenceQuery, GetSqPrefillPreferenceQueryVariables>(
        GetSqPrefillPreferenceDocument,
        options,
    );
}
export function useGetSqPrefillPreferenceSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetSqPrefillPreferenceQuery,
              GetSqPrefillPreferenceQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetSqPrefillPreferenceQuery,
        GetSqPrefillPreferenceQueryVariables
    >(GetSqPrefillPreferenceDocument, options);
}
export type GetSqPrefillPreferenceQueryHookResult = ReturnType<
    typeof useGetSqPrefillPreferenceQuery
>;
export type GetSqPrefillPreferenceLazyQueryHookResult = ReturnType<
    typeof useGetSqPrefillPreferenceLazyQuery
>;
export type GetSqPrefillPreferenceSuspenseQueryHookResult = ReturnType<
    typeof useGetSqPrefillPreferenceSuspenseQuery
>;
export type GetSqPrefillPreferenceQueryResult = Apollo.QueryResult<
    GetSqPrefillPreferenceQuery,
    GetSqPrefillPreferenceQueryVariables
>;
